<template>
	<div class="kuaidi_box">
		<div class="kuaidi_left">
			<Tuodongdaxiao v-for="(l,i) in mianban_shu.shu" :shu.sync="l" :i="i" @Youji="Youji" @Zuoji="Zuoji" v-if="l">
				<div>{{l.wenzi}}</div>
			</Tuodongdaxiao>
			<div class="Youjicaidan" :style="youjiyangshi">
				<div @click="Cengci(1)">上一层</div>
				<div @click="Cengci(2)">下一层</div>
				<div @click="Cengci(3)">删除</div>
				<div @click="Cengci(0)">取消</div>
			</div>
		</div>
		<div class="kuaidi_right">
			<el-tabs type="border-card">
				<el-tab-pane label="快递模板">
					<el-form ref="form" style="">
						<el-form-item label="" label-width="10">
							<el-input placeholder="请输入内容" size="small">
								<template slot="prepend">名称</template>
							</el-input>
						</el-form-item>
						<el-form-item label="" label-width="10">
							<el-input placeholder="请输入值" size="small">
								<template slot="prepend" >单据宽度</template>
								<template slot="append">mm</template>
							</el-input>
						</el-form-item>
						<el-form-item label="" label-width="10">
							<el-input placeholder="请输入值" size="small">
								<template slot="prepend">单据高度</template>
								<template slot="append">mm</template>
							</el-input>
						</el-form-item>
						<el-form-item label="" label-width="10" style="border-top:1px solid #ebebeb;">
							<div style="font-size: 18px; color: #c1c1c1;padding-left: 20px;">字段</div>
						<!-- <el-checkbox-group v-model="form.type" style="padding: 0 30px;display: flex;flex-wrap: wrap;justify-content: space-between;">
							    <el-checkbox label="发件人"  @change="Tianjia({kuan: 100,gao: 100,leixing: 'nicheng',z: 1,wenzi:'发件人'})"/>
							    <el-checkbox label="发件人电话"/>
							    <el-checkbox label="发件地址"/>
							    <el-checkbox label="发件人签名"/>
							    <el-checkbox label="发件邮编"/>
							    <el-checkbox label="发件日期"/>
							    <el-checkbox label="商品明细"/>
							    <el-checkbox label="商城名称"/>
							    <el-checkbox label="发件城市"/>
							    <el-checkbox label="收件人"/>
							    <el-checkbox label="收件人电话"/>
							    <el-checkbox label="收件省份"/>
							    <el-checkbox label="收件人城市"/>
							    <el-checkbox label="收件人区域"/>
							    <el-checkbox label="收件人地址"/>
								<el-checkbox label="买家昵称"/>
					     </el-checkbox-group> -->
						
						</el-form-item>
						<el-form-item  label-width="10" >
							<el-button-group style="position: relative;display: flex;flex-wrap: wrap;justify-content: flex-start;" class="">
								 <el-button @click="Tianjia({kuan: 100,gao: 100,leixing: 'fajianren',z: 1, wenzi:'发件人'})" size="small">发件人</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'dianhua',z: 1, wenzi:'发件人电话'})" size="small">发件人电话</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 100,leixing: 'fajiandizhi',z: 1, wenzi:'发件地址'})" size="small">发件地址</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'qianming',z: 1, wenzi:'发件人签名'})" size="small">发件人签名</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'youbian',z: 1, wenzi:'发件邮编'})" size="small">发件邮编</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 100,leixing: 'riqi',z: 1, wenzi:'发件日期'})" size="small">发件日期</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'mingxi',z: 1, wenzi:'商品明细'})" size="small">商品明细</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'mingcheng',z: 1, wenzi:'商城名称'})" size="small">商城名称</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'fajiangcity',z: 1, wenzi:'发件城市'})" size="small">发件城市</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'shoujianren',z: 1, wenzi:'收件人'})" size="small">收件人</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'shoujianshenfen',z: 1, wenzi:'收件省份'})" size="small">收件省份</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'shoujiancity',z: 1, wenzi:'收件人城市'})" size="small">收件人城市</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'shoujianquyu',z: 1, wenzi:'收件人区域'})" size="small">收件人区域</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'shoujiandizhi',z: 1, wenzi:'收件人地址'})" size="small">收件人地址</el-button>
								 <el-button @click="Tianjia({kuan: 100,gao: 30,leixing: 'nicheng',z: 1, wenzi:'买家昵称'})" size="small">买家昵称</el-button>
							</el-button-group>
						</el-form-item>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="属性">
					<el-form ref="form" label-width="80px" style="">
						<el-form-item label="" label-width="10" style="display: flex;">
							<template>
							<el-button style="background: #f5f7fa; color: #909399;" size="small">字体</el-button>
							  <el-select v-model="value" placeholder="请选择" style="width: 30%" size="small">
							    <el-option v-for="l in ziti" :key="l.value" :label="l.label" :value="l.value">
							    </el-option>
							  </el-select>
							 </template>
							 <template>
							 <el-button style="background: #f5f7fa; color: #909399;" size="small">大小</el-button>
							   <el-select v-model="value1" placeholder="请选择" style="width: 30%" size="small">
							     <el-option v-for="l in daxia" :key="l.value" :label="l.label" :value="l.value">
							     </el-option>
							   </el-select>
							  </template>
						</el-form-item>
						<el-form-item label="" label-width="10" style="display: flex;">
							<template>
							<el-button style="background: #f5f7fa; color: #909399;" size="small">对齐</el-button>
							  <el-select v-model="value" placeholder="请选择" style="width: 30%" size="small">
							    <el-option  label="居左" value="1"/>
								<el-option  label="居中" value="2"/>
								<el-option  label="居右" value="3"/>
							  </el-select>
							 </template>
							 <template>
							 <el-button style="background: #f5f7fa; color: #909399;" size="small">加粗</el-button>
							   <el-select v-model="value1" placeholder="请选择" style="width: 30%" size="small" >
							    <el-option  label="不加粗"value="1"/>
							    <el-option  label="加粗" value="2"/>
							   </el-select>
							  </template>
						</el-form-item>
						<el-form-item label="" label-width="10" style="display: flex;">
							<div>
							<el-input placeholder="请输入颜色" style="width: 60%;" size="small" v-model="color1">
								<template slot="prepend" size="small">颜色</template>
							</el-input>
							<el-tooltip content="选择颜色" placement="top" effect="light">
								<el-color-picker v-model="color1" size="small"></el-color-picker>
							</el-tooltip>
							</div>
							<!-- <el-button  style="background: #FFFFFF;" @click="xuan" size="small">选择颜色<i class="el-icon-caret-bottom" size="small"></i></el-button> -->
							
						</el-form-item>
						<el-form-item label="" label-width="10" style="display: flex;">
							<el-input placeholder="请输入文字" style="width: 50%;" size="small">
								<template slot="prepend">前文字</template>
							</el-input>
							<el-input placeholder="请输入文字" style="width: 50%;" size="small">
								<template slot="prepend">后文字</template>
							</el-input>
						</el-form-item>
					</el-form>
				</el-tab-pane>
			</el-tabs>
		</div>

	</div>
</template>

<script>
	// const baiodanOptions = ['发件人', '发件人电话', '发件地址', '发件人签名','发件邮编','发件日期','商品明细','商城名称','发件城市','收件人','收件人电话',
	// '收件省份','收件人城市','收件人区域','收件人地址','买家昵称'];
	import Tuodongdaxiao from '../../zujian/Tuodongdaxiao.vue'
	export default {
		data() {
			return {
				so: {
					ye: 1,
					jitiao: 20
				},
				lie: [],
				shu: {},
				tabs: 'lie',
				// biaodanlie: baiodanOptions,
				form: {type:[]},
				ziti:[{label:'宋体',value:'3'},{label:'宋体',value:'4'},{label:'宋体',value:'1'}],
				daxia:[{label:'21',value:'3'},{label:'13',value:'4'},{label:'25',value:'1'}],
				value:'',
				value1:'',
				yanse:0,
				color1:'',
				tuodongdaxiao: {},
				youjiyangshi: '',
				mianban_shu: {shu:[]},
			}
		},
		components: {
		Tuodongdaxiao
		},
		methods: {
			xuan:function(){
				this.yanse=!this.yanse
			},
			Youji(a, b) {
				this.tuodongdaxiao = b;
				this.youjiyangshi = "left:" + (a.layerX + b.x) + "px;top:" + (a.layerY + b.y) + 'px;display:block';
			},
			Zuoji(e) {
				this.tuodongdaxiao = e;
				console.log(this.tuodongdaxiao)
				if(e.leixing=="nicheng"){this.niCheng2=true }else{this.niCheng2=false;}
				if(e.leixing=="tuijianma"){this.tuijianma2=true }else{this.tuijianma2=false;}
				if(e.leixing=="shangpinming"){this.shangpinming2=true }else{this.shangpinming2=false;}
				if(e.leixing=="shangpinjiage"){this.shangpinjiage2=true }else{this.shangpinjiage2=false;}
				if(e.leixing=="shangpinyuanjia"){this.shangpinyuanjia2=true }else{this.shangpinyuanjia2=false;}
			},
			Cengci(e) {
				if (e == 1) {
					this.tuodongdaxiao.z += 1;
				} else if (e == 2 && this.tuodongdaxiao.z > 0) {
					this.tuodongdaxiao.z -= 1;
				} else if (e == 3) {
					this.mianban_shu.shu[this.tuodongdaxiao.i] = false;
				}
				this.youjiyangshi = 'display:none';
			},
			Tianjia(e) {
				e.x=0;
				e.y=0;
				// e.wenzi="好了"
			
				
				this.mianban_shu.shu.push(e)
			},
		},
	}
</script>

<style>
	body {
		background: #f9f9f9;
	}

	.kuaidi_box {
		padding: 30px;
		/* display: flex;
		justify-content: space-between; */
	}

	.kuaidi_left {
		width: 55%;
		/* padding: 30px; */
		background: #FFFFFF;
		float: left;
		height: 500px;
		position: relative;
	}

	.kuaidi_right {
		width: 35%;
		background: #FFFFFF;
		float: right;
	}

	.kuaidi_right_bottom {}
	.el-button-group .el-button{
		margin-bottom: 20px;
	}
</style>
